import * as React from "react";
import {
  ArrayInput,
  AutocompleteInput,
  Edit,
  EditProps,
  ReferenceInput,
  SimpleForm,
  SimpleFormIterator,
  TextInput,
  TranslatableInputs,
  useLocaleState,
} from "react-admin";

const LayoutEdit = (props: EditProps) => {
  const [locale] = useLocaleState();

  return (
    <Edit {...props} mutationOptions={{ meta: { fileUpload: true } }}>
      <SimpleForm style={{ display: "flex", width: "100%" }}>
        <TranslatableInputs fullWidth defaultLocale={locale} locales={["pl"]}>
          <TextInput fullWidth source="phone" label="layout.phone" />
          <TextInput fullWidth source="email" label="layout.email" />
          <TextInput fullWidth source="slogan" label="layout.slogan" />
          <TextInput fullWidth source="copyright" label="layout.copyright" />

          <ArrayInput source="options" label="layout.options">
            <SimpleFormIterator fullWidth>
              <TextInput fullWidth source="option" label="layout.option" />
              <ReferenceInput fullWidth source="link" reference="services">
                <AutocompleteInput
                  fullWidth
                  label="layout.link"
                  optionText={`serviceName.${locale}`}
                />
              </ReferenceInput>
            </SimpleFormIterator>
          </ArrayInput>
        </TranslatableInputs>
      </SimpleForm>
    </Edit>
  );
};

export default LayoutEdit;
